'use strict';

import AppDispatcher from '../dispatcher/AppDispatcher';
import ChunkLoadingConstants from '../constants/ChunkLoadingConstants';

const ChunkLoadingActions = {

    setIsChunkLoading(isChunkLoading) {
        setTimeout(() => {
            AppDispatcher.handleViewAction({
                actionType: ChunkLoadingConstants.UPDATE_IS_CHUNK_LOADING,
                isChunkLoading,
            });
        }, 0);
    }
}

export default ChunkLoadingActions;
